import { connect } from "react-redux";
import { Dispatch } from "react";
import { RootState } from "redux/reducers/RootReducer";
import CnicVerificationPage from "components/pages/cnicVerification/CnicVerificationPage";
import {
  IGetQueryParams,
  ICnicVerificationRequestPayload,
} from "interfaces/Index";
import actions from "redux/actions/Index";
export const mapStateToProps = (state: RootState, props: any): any => {
  const {
    cnicVerification: {
      error,
      cnicVerificationData,
      isCnicVerificationDataFetched,
      isCnicVerificationDataFetchedError,
      pagination,
      isCnicVerified,
    },
    zone: { citiesList, isCityListFetched },
  } = state;
  return {
    error,
    cnicVerificationData,
    isCnicVerificationDataFetched,
    isCnicVerificationDataFetchedError,
    pagination,
    isCnicVerified,
    citiesList,
    isCityListFetched,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    fetchCnicVerificationData: (queryParams?: IGetQueryParams) =>
      dispatch(actions.getCnicVerificationDataAction(queryParams)),
    verifyCnicData: (payload: ICnicVerificationRequestPayload) =>
      dispatch(actions.verifyCnicDataAction(payload)),
    fetchCities: () => dispatch(actions.fetchCities()),
  };
};

const CnicVerificationContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CnicVerificationPage);
export default CnicVerificationContainer;
